// extracted by css-extract-rspack-plugin
export default {"cls1":"StickyWorkCardHeader-cls1_O56","cls2":"StickyWorkCardHeader-cls2_Jrl StickyWorkCardHeader-cls1_O56"};